import { render, staticRenderFns } from "./SuperVisorList.vue?vue&type=template&id=0b465767&scoped=true"
import script from "./SuperVisorList.vue?vue&type=script&lang=js"
export * from "./SuperVisorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b465767",
  null
  
)

export default component.exports